var _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineDashed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 4,
    viewBox: "0 0 46 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1.84472,
    y1: 2,
    x2: 50,
    y2: 2,
    stroke: "#E1E1E1",
    strokeWidth: 3.33007,
    strokeLinecap: "square",
    strokeDasharray: "11.66 11.66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineDashed);
export default __webpack_public_path__ + "static/media/LineDashed.188c70d97d55ff9c3cb7a03e7a9c05d1.svg";
export { ForwardRef as ReactComponent };